import { render, staticRenderFns } from "./UserCommissions.vue?vue&type=template&id=13a24698&"
import script from "./UserCommissions.vue?vue&type=script&lang=ts&"
export * from "./UserCommissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports